import { IWPImage, IWPLink } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";
import { useLocalization } from "../../../contexts/Localization";
import { Languages } from "@/src/types";

export type IHeaderData = {
  wp: {
    siteSettings: {
      siteSettings: {
        form: {
          boxicon: string;
        }
        header: {
          links: {
            link: IWPLink;
            hasSubmenu: boolean;
            submenuTitle: string;
            subLinks: {
              link: IWPLink;
              description: string;
              boxicon: string;
            }[];
            submenuLink: IWPLink;
          };
          logo: IWPImage;
          label: string;
          quoteLabel: string;
          topHeader: {
            phoneNumber: string;
            email: string;
            link: IWPLink;
          };
        };
      };
    };
  };
};

const useHeaderData = (lang: Languages) => {
  const { wp }: IHeaderData = useStaticQuery(
    graphql`
      {
        wp {
          siteSettingsSV {
            acf_settings {
              form {
                boxicon
              }
              header {
                links {
                  link {
                    target
                    title
                    url
                  }
                  hasSubmenu
                  submenuTitle
                  sublinks {
                    link {
                      target
                      title
                      url
                    }
                    description
                    boxicon
                  }
                  submenuLink {
                    target
                    title
                    url
                  }
                }
                logo {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(placeholder: BLURRED, width: 50)
                    }
                  }
                  altText
                }
                label
                quoteLabel
                topHeader {
                  phoneNumber
                  email
                  link {
                    target
                    title
                    url
                  }
                }
              }
            }
          }
          siteSettingsEN {
            acf_settings {
              form {
                boxicon
              }
              header {
                links {
                  link {
                    target
                    title
                    url
                  }
                  hasSubmenu
                  submenuTitle
                  sublinks {
                    link {
                      target
                      title
                      url
                    }
                    description
                    boxicon
                  }
                  submenuLink {
                    target
                    title
                    url
                  }
                }
                logo {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        formats: AUTO
                        layout: FULL_WIDTH
                        placeholder: BLURRED
                      )
                    }
                  }
                  altText
                }
                label
                quoteLabel
                topHeader {
                  phoneNumber
                  email
                  link {
                    target
                    title
                    url
                  }
                }
              }
            }
          }
          siteSettingsZH {
            acf_settings {
              header {
                links {
                  link {
                    target
                    title
                    url
                  }
                  hasSubmenu
                  submenuTitle
                  sublinks {
                    link {
                      target
                      title
                      url
                    }
                    description
                    boxicon
                  }
                  submenuLink {
                    target
                    title
                    url
                  }
                }
                logo {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        formats: AUTO
                        layout: FULL_WIDTH
                        placeholder: BLURRED
                      )
                    }
                  }
                  altText
                }
                label
                quoteLabel
                topHeader {
                  phoneNumber
                  email
                  link {
                    target
                    title
                    url
                  }
                }
              }
              form {
                boxicon
              }
            }
          }
        }
      }
    `
  );
  return wp[`siteSettings${lang.toUpperCase()}`].acf_settings;
};
export default useHeaderData;
